var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "cell-intervals" }, [
    _c(
      "tbody",
      _vm._l(_vm.intervalsLocalItems, function (interval, ind) {
        return _c(
          "tr",
          {
            key: `cell-intervals-${ind}`,
            staticClass: "cell-intervals-table-row",
          },
          [
            _c(
              "td",
              {
                staticClass: "cell-intervals-table-cell",
                class: {
                  "cell-intervals-table-cell-required": !interval.isValid,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "cell-intervals-item" },
                  [
                    _c("c-input", {
                      staticClass: "cell-intervals-item-input",
                      attrs: {
                        type: "text",
                        mask: "##:## – ##:##",
                        placeholder: "00:00 – 00:00",
                      },
                      model: {
                        value: interval.interval,
                        callback: function ($$v) {
                          _vm.$set(interval, "interval", $$v)
                        },
                        expression: "interval.interval",
                      },
                    }),
                    _c("c-button", {
                      staticClass: "cell-intervals-item-remove",
                      class: {
                        "cell-intervals-item-remove-hidden":
                          _vm.intervalsLocalItems.length === 1,
                      },
                      attrs: {
                        size: "iconic",
                        icon: { icon: "close", color: "secondary" },
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removeInterval(ind)
                        },
                      },
                    }),
                    ind === _vm.intervalsLocalItems.length - 1
                      ? _c("c-button", {
                          staticClass: "cell-intervals-item-add",
                          attrs: {
                            size: "iconic",
                            icon: { icon: "plus", color: "green" },
                          },
                          on: { click: _vm.addInterval },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }